module.exports = __webpack_public_path__ + "static/media/icone_viagem_aberta.344d191a.png";